import React from "react";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
import media from "src/core/common/themes/media";
import Rating from "../../../../core/common/components/modules/Rating";
import styles from "src/themes/colorful/elements/BrandHeader/styles";
import {TheColorFulTitle} from "src/themes/colorful/elements/Title";
import {useTheme} from "styled-components";
import useSite from "src/core/sites/hooks/useSite";

function TheColorFulBrandHeader(props) {
  const site = useSite();

  function createMarkup(description) {
    return {__html: description};
  }

  const {brand} = props;
  const theme = useTheme();

  if (!brand) {
    return (
      <HeaderContainer>
        <CentralHeader logo={false} description={false}>
          <Skeleton height={32} width={250} />
        </CentralHeader>
      </HeaderContainer>
    );
  } else {
    const logo = brand.getLogo();
    const description = brand.getDescription();
    const name = brand.getName();
    const rating = brand.getRating();
    return (
      <HeaderContainer>
        {logo && (
          <BrandContainer>
            {logo && <BrandLogo src={logo} alt={"brand logo"} />}
          </BrandContainer>
        )}
        <CentralHeader logo={logo} description={description}>
          <BrandName logo={logo} description={description} styles={styles(theme, site)}>
            {name}
          </BrandName>
          <RateReview style={{display: "none"}}>
            <Rating readonly={true} initialRating={rating} size={"20px"} />
          </RateReview>
          <Description dangerouslySetInnerHTML={createMarkup(description)} />
        </CentralHeader>
      </HeaderContainer>
    );
  }
}

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding: 0 ${({theme}) => `${theme.v2.spacing(8)}`};

  ${media.between("sm", "lg")} {
    padding: 0
      ${({theme}) =>
        `${theme.v2.spacing(4)} ${theme.v2.spacing(4)} ${theme.v2.spacing(4)}`};
  }

  ${media.down("sm")} {
    padding: ${({logo, theme}) => (logo ? theme.v2.spacing(4) : 0)}
      ${({theme}) => theme.v2.spacing(4)};
    flex-direction: column;
    align-items: center;
  }
`;

const BrandContainer = styled.div`
  min-width: 200px;
  max-width: 200px;
  height: 200px;
`;

const BrandLogo = styled.img`
  width: 200px;
  height: 100%;
  object-fit: contain;
`;

const CentralHeader = styled.div`
  flex-grow: 1;
  padding-left: ${({logo, theme}) => (logo ? theme.v2.spacing(8) : 0)};
  display: flex;
  flex-direction: column;
  justify-content: ${({description}) => (description ? "space-between" : "center")};

  ${media.down("sm")} {
    padding: ${({logo, theme}) => (logo ? theme.v2.spacing(8) : 0)} 0;
    padding-bottom: ${({description, theme}) => (description ? theme.v2.spacing(8) : 0)};
    flex-direction: column;
    width: 100%;
  }
`;

const BrandName = styled(TheColorFulTitle)``;

const RateReview = styled.div`
  display: flex;
  align-items: center;
  padding-top: ${({theme}) => theme.v2.spacing(2)};

  ${media.down("sm")} {
    justify-content: space-between;
    padding-top: 0;
    padding-bottom: ${({theme}) => theme.v2.spacing(4)};
  }
`;

const Description = styled.div`
  line-height: ${({theme}) => theme.v2.typography.bodyText1.lineHeight};
  font-family: ${({theme}) => theme.v2.typography.bodyText1.family};
  text-align: justify;
  font-size: ${({theme}) => theme.v2.typography.bodyText1.size.lg};

  ${media.down("md")} {
    font-size: ${({theme}) => theme.v2.typography.bodyText1.size.md};
  }

  ${media.down("sm")} {
    font-size: ${({theme}) => theme.v2.typography.bodyText1.size.md};
  }
`;

export default TheColorFulBrandHeader;
